import { TrainingMembershipsDataTableQuery } from 'generated/resources/datatable.graphql'
import compact from 'lodash/compact'

import { useDataTable } from 'modules/core/components/DataTable'

import { AddToClassModal } from 'modules/trainings/components/Revamp/TrainingsDetail/TrainingEmployeesDataTable/AddToClassModal'

const AssignParticipants = () => {
  const data = useDataTable<TrainingMembershipsDataTableQuery>()
  const selectedAccessIds = compact(
    data.queryResult.data?.trainings.trainingMembershipsConnection.edges.map((membership) => {
      if (data.selectedRows.has(String(membership.node?.id))) {
        return membership.node?.accessId
      }
    })
  )

  return <AddToClassModal accessIds={selectedAccessIds} />
}

export default AssignParticipants
